var DRAFT_PREFIX = 'proposal_builder_draft_';
var TEMPLATE_DRAFT_PREFIX = 'proposal_template_builder_draft_';
export function getProposalDraftKey(proposalId) {
  return "".concat(DRAFT_PREFIX).concat(proposalId);
}
export function getTemplateDraftKey(templateId) {
  return "".concat(TEMPLATE_DRAFT_PREFIX).concat(templateId);
}
function saveDraftToSession(key, design, html) {
  if (!key) {
    return;
  }
  try {
    sessionStorage.setItem(key, JSON.stringify({
      design: design,
      html: html,
      savedAt: Date.now()
    }));
  } catch (error) {
    console.warn('Failed to save builder draft to session', error);
  }
}
function loadDraftFromSession(key) {
  if (!key) {
    return null;
  }
  try {
    var raw = sessionStorage.getItem(key);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Failed to load builder draft from session', error);
    return null;
  }
}
function clearDraftFromSession(key) {
  if (!key) {
    return;
  }
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.warn('Failed to clear builder draft from session', error);
  }
}
export function saveProposalDraftToSession(proposalId, design, html) {
  saveDraftToSession(getProposalDraftKey(proposalId), design, html);
}
export function loadProposalDraftFromSession(proposalId) {
  return loadDraftFromSession(getProposalDraftKey(proposalId));
}
export function clearProposalDraftFromSession(proposalId) {
  clearDraftFromSession(getProposalDraftKey(proposalId));
}
export function saveTemplateDraftToSession(templateId, design, html) {
  saveDraftToSession(getTemplateDraftKey(templateId), design, html);
}
export function loadTemplateDraftFromSession(templateId) {
  return loadDraftFromSession(getTemplateDraftKey(templateId));
}
export function clearTemplateDraftFromSession(templateId) {
  clearDraftFromSession(getTemplateDraftKey(templateId));
}